// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__34LGQ","upload":"Small_upload__1CLAm","imageWrap":"Small_imageWrap__3ixAm","removeBtn":"Small_removeBtn__1KCKE"};